export default __webpack_public_path__ + "static/media/dubai-international-financial-centre.3bad6ae0.png";